import { CookieService } from '../services/cookie-service';
import * as Cookies from '../constants/cookies';

export const useIsSSLiteSwitchCookiePresent = (): boolean => Boolean(CookieService.getCookieValue(Cookies.SSLiteSwitch));
